export default __webpack_public_path__ + "static/media/flavorsGradientTransition.9c0bbd36.svg";